import { z } from "zod";

export function zPathParamId<A extends z.ZodTypeAny, B extends PropertyKey>(
  branded: z.ZodBranded<A, B>
) {
  return z.string().transform((x) => branded.parse(parseInt(x, 10)));
}
